export default __webpack_public_path__ + "static/media/info-white.02989c87.svg";